import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


import { useStore } from "../../../hook-store/store.js";
import { getSpeechToTextModels } from "../../../utils/transcribe-audio-utils/speech-to-text.js";

import { TEXTAUDIOTOOLSNODE_URL } from "../../../App.js";

import "./TranscribeModels.css";

//// test files https://www.voiceover-samples.com/languages/


export default function TranscribeModels(props) {
    const { 
    } = props;


    const [t] = useTranslation("translation");

    const [store, dispatch] = useStore();
    const { 
        mlSpeechModels,
        mlSpeechSelectedLanguage,
        mlSpeechSelectedModel,
        mlSpeechInputFileName,
    } = store.mlSpeechStore;

    useEffect(() => {
      if (!mlSpeechModels) {
        getSpeechToTextModelsHandler();
      }
    },[mlSpeechInputFileName]);

    useEffect(() => {
      return () => {
        dispatch('SET_MLSPEECHSELECTEDLANGUAGE', '');
        dispatch('SET_MLSPEECHSELECTEDMODEL', '');
      }
    },[])



    const getSpeechToTextModelsHandler = async () => {
      try {
        const resData = await getSpeechToTextModels(
          TEXTAUDIOTOOLSNODE_URL,
          localStorage.getItem('token'),
        );

        // console.log(resData);

        if (resData.data.models) {
          dispatch('SET_MLSPEECHMODELS', resData.data.models);
        }

        if (resData.data.speechToTextConfig) {
          dispatch('SET_MLSPEECHTOTEXTCONFIG', resData.data.speechToTextConfig)
        }

      } catch(err) {
        console.log(err);
        throw err;
      }
    };

    const setSelectedLanguageHandler = (value) => {
      dispatch('SET_MLSPEECHSELECTEDLANGUAGE', value);
      dispatch('SET_MLSPEECHSELECTEDMODEL', '');
    };

    const setSelectedModelHandler = (value) => {
      dispatch('SET_MLSPEECHSELECTEDMODEL', value);
    }


    const lngList = ['', ];
    const lngModels = ['', ];
    let displayModelNameEl;


    if (mlSpeechModels) {
      for (const lng in mlSpeechModels) {
        lngList.push(lng);
      }
    }

    if (mlSpeechSelectedLanguage) {
      for (const model of mlSpeechModels[mlSpeechSelectedLanguage]) {
        if (model !== "whisper-small.en") {
          lngModels.push(model);
        }
      }
    }

    if (mlSpeechModels && mlSpeechSelectedModel && mlSpeechSelectedLanguage) {
      displayModelNameEl = (
        <span>
          {mlSpeechSelectedLanguage} - {mlSpeechModels[mlSpeechSelectedLanguage].indexOf(mlSpeechSelectedModel)+1}
          {' '}(...{mlSpeechSelectedModel.slice(-20, mlSpeechSelectedModel.length)})
        </span>
      );
    }

    // console.log(mlSpeechModels[mlSpeechSelectedLanguage].indexOf(mlSpeechSelectedModel))

    let transcribeModelsBody;

    if (mlSpeechModels) {
      transcribeModelsBody = (
        <div>
          <div className="transcribeModelsTitle">
            <strong>
              Audio Transcriber {t('audioTranscriber19', 'Settings')}
            </strong>
          </div>
          <div className="transcribeModels">
            <div className="transcribeModelsRow">
              <div>
                <label>
                  {t('audioTranscriber20', 'Select Language')}
                </label>
              </div>
              <select className='selectBase'
                // name="pets" 
                // id="pet-select"
                defaultValue={''}
                value={mlSpeechSelectedLanguage}
                onChange={(event) => { 
                  setSelectedLanguageHandler(event.target.value)
                }}
              >
                {lngList.map(element => {
                  return (
                    <option 
                      value={element}
                    >
                      {element}
                    </option>
                  )
                })}
              </select>
              <div>
                <span>
                  {t('audioTranscriber21', 'Selected Language')}: 
                </span>
                <strong>
                  {' '}{mlSpeechSelectedLanguage}
                </strong>
              </div>
            </div>

            <div className="transcribeModelsRow">
              <div>
                <label>
                  {t('audioTranscriber22', 'Select Model')}
                </label>
              </div>
              <select className='selectBase'
                // name="pets" 
                // id="pet-select"
                defaultValue={''}
                value={mlSpeechSelectedModel}
                onChange={(event) => { 
                  setSelectedModelHandler(event.target.value)
                }}
              >
                {lngModels.map((element, index) => {
                  if (index === 0) {
                    return (
                      <option 
                        value={element}
                      >
                        {element}
                      </option>
                    );
                  } else {
                    return (
                      <option value={element}>
                        {mlSpeechSelectedLanguage} - {index} (...{element.slice(-20, element.length)})
                      </option>
                    )
                  }

                })}
              </select>
              {mlSpeechSelectedModel && (
                <div>
                  <span>
                    {t('audioTranscriber23', 'Selected Model')}: 
                  </span>
                  <strong>
                    {' '}{displayModelNameEl}
                  </strong>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
    return (
        <Fragment>
          {mlSpeechModels && (
            <div>
              {transcribeModelsBody}
              {/* {JSON.stringify(mlSpeechModels)} */}
            </div>
          )}
       
        </Fragment>
    );
  };
